import { useEffect, useMemo, useState } from 'react';
import { resolveThaiZipCascade } from '../utils/functions/thaiZipCascade';

// รวม logic auto-fill จังหวัด/อำเภอ/ตำบล จากรหัสไปรษณีย์ไว้ในที่เดียว ใช้ร่วมกันได้ทั้งฟอร์มเพิ่มและแก้ไข
// (ก่อนหน้านี้ต้อง copy ทั้ง useMemo + useEffect ซ้ำสำหรับ add/edit form แยกกัน)
export default function useZipCascade(watch, setValue) {
  const [zipSelections, setZipSelections] = useState({ province: null, district: null });
  const zipValue = watch('zipcode');

  const cascade = useMemo(
    () => resolveThaiZipCascade(zipValue, zipSelections.province, zipSelections.district),
    [zipValue, zipSelections],
  );

  useEffect(() => {
    setValue('province', cascade.province || '');
    setValue('amphoe', cascade.amphoe || '');
    setValue('tambon', cascade.tambon || '');
  }, [cascade, setValue]);

  return { cascade, setZipSelections };
}
